angular.module('study.ecrd.queries')
    .config(['$stateProvider', 'RouteProvider', function($stateProvider, RouteProvider) {
        $stateProvider.state(RouteProvider.create('queries', {
            url: '/queries',
            component: 'queriesMain',
            pageTitle: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Notas de discrepancia');
            }],
            permission: 'access study queries',
            redirectTo: 'queries.openQueries',
            resolve: {
                redirectToRecord: ['$state', function($state) {
                    return ['recordId', 'target', function(recordId, target) {
                        $state.go('record.edit.data', {
                            recordId: recordId,
                            target: target,
                        });
                    }];
                }],
            },
        }));

        $stateProvider.state(RouteProvider.create('queries.openQueries', {
            url: '/open',
            component: 'queriesListOpen',
            pageTitleComponent: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Abiertas', {}, 'Queries abiertas');
            }],
        }));

        $stateProvider.state(RouteProvider.create('queries.closedQueries', {
            url: '/closed',
            component: 'queriesListClosed',
            pageTitleComponent: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Cerradas', {}, 'Queries cerradas');
            }],
        }));
    }]);
